import { axiosApi } from 'shared/api/axios'
import { PaymentEndpoint } from 'entities/payments/api/contants'

export const cancelPayment = async (paymentId: number) => {
    try {
        await axiosApi.patch(PaymentEndpoint.CancelPayments(paymentId))
        return true
    } catch (err: any) {
        throw new Error(
            `Ошибка отмены платежа: ${err?.response?.data?.detail}`,
        )
    }
}
